import Button from '@shared/components/core/button/CoreButton';
import StyledTextField from '@shared/components/core/field/StyledTextField';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import { SubSectionContent } from '@shared/components/core/layouts/CommonLayoutStyles';
import { usePasswordManager } from '@shared/hooks/userSettings/usePasswordManagement';
import { useTranslation } from 'react-i18next';

// TODO CONSIDER: consider moving this to a dialog
export default function PasswordResetSection() {
    const { t } = useTranslation();
    const {
        oldPassword,
        setOldPassword,
        newPassword,
        setNewPassword,
        confirmNewPassword,
        setConfirmNewPassword,
        handleSavePassword,
    } = usePasswordManager();

    return (
        <>
            <SubSectionRow
                title={t('common:account.password.change')}
                description={t('common:account.password.description')}
            />
            <SubSectionContent>
                <StyledTextField
                    fullWidth
                    label={t('common:account.password.old')}
                    type="password"
                    placeholder={t('common:account.password.current')}
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                />
                <StyledTextField
                    fullWidth
                    label={t('common:account.password.new')}
                    type="password"
                    placeholder={t('common:account.password.desired')}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <StyledTextField
                    fullWidth
                    label={t('common:account.password.confirm')}
                    type="password"
                    placeholder={t('common:account.password.desired')}
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                />
                <Button onClick={handleSavePassword}>{t('common:save')}</Button>
            </SubSectionContent>
        </>
    );
}
